import { api } from './api';

// Define a user service
export const userApi = api.injectEndpoints({
  reducerPath: 'userApi',
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => ({
        url: `/api/administration/users`,
        method: 'GET'
      }),
      providesTags: ['Users']
    }),
    createUser: builder.mutation({
      query: (userRequest) => ({
        url: `/api/administration/users`,
        method: 'POST',
        body: userRequest
      }),
      invalidatesTags: ['Users']
    }),
    updateUser: builder.mutation({
      query: ({ userId, userRequest }) => ({
        url: `/api/administration/users/${userId}`,
        method: 'PATCH',
        body: userRequest
      }),
      invalidatesTags: ['Users']
    }),
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `/api/administration/users/${userId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Users']
    }),
    bulkDeleteUsers: builder.mutation({
      query: (userIds) => ({
        url: `/api/administration/users`,
        method: 'DELETE',
        body: userIds
      }),
      invalidatesTags: ['Users']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useBulkDeleteUsersMutation
} = userApi;
